import Image from "next/image";

import { ElementEnum } from "@sorcery/db";

import type { DeckPreviewType } from "~/types/deck";
import { earth, fire, water, wind } from "~/utils/element";

export const DeckThreshholds = ({
  elements,
  size = 12,
}: {
  elements: DeckPreviewType["elements"];
  size?: number;
}) => {
  const hasEarth = elements.some((e) => e.name === ElementEnum.Earth);
  const hasFire = elements.some((e) => e.name === ElementEnum.Fire);
  const hasWater = elements.some((e) => e.name === ElementEnum.Water);
  const hasAir = elements.some((e) => e.name === ElementEnum.Air);

  return (
    <div className="whitespace-nowrap text-text-color">
      {hasEarth && (
        <Image
          src={earth}
          width={size}
          height={size}
          className="inline-block brightness-125"
          alt=""
        />
      )}

      {hasFire && (
        <Image
          src={fire}
          width={size}
          height={size}
          className="inline-block brightness-125"
          alt=""
        />
      )}

      {hasWater && (
        <Image
          src={water}
          width={size}
          height={size}
          className="inline-block brightness-125"
          alt=""
        />
      )}

      {hasAir && (
        <Image
          src={wind}
          width={size}
          height={size}
          className="inline-block brightness-125"
          alt=""
        />
      )}
    </div>
  );
};
